var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0 18 18 0 18z",
    transform: "translate(-40 -7149) translate(0 6947) translate(40 201)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17174A",
    fillRule: "nonzero",
    d: "M13.412 14.473c-1.32.836-2.85 1.28-4.412 1.277-4.044 0-7.409-2.91-8.114-6.75.322-1.747 1.201-3.343 2.505-4.55L1.044 2.107l1.061-1.061 14.85 14.85-1.062 1.06-2.482-2.482zm-8.96-8.96C3.431 6.439 2.721 7.657 2.416 9c.475 2.078 1.903 3.81 3.853 4.672 1.95.862 4.191.753 6.048-.293l-1.521-1.521c-1.334.84-3.07.645-4.185-.47-1.115-1.114-1.31-2.851-.47-4.185l-1.69-1.69zm5.233 5.233L7.254 8.315c-.273.694-.108 1.484.42 2.01.527.528 1.317.693 2.01.42l.002.001zm5.92 1.698l-1.073-1.073c.501-.714.858-1.52 1.05-2.371-.411-1.804-1.545-3.36-3.137-4.305-1.59-.944-3.5-1.194-5.281-.692L5.981 2.82c.935-.367 1.954-.57 3.019-.57 4.044 0 7.409 2.91 8.114 6.75-.23 1.25-.746 2.428-1.509 3.444zM8.792 5.631c.966-.06 1.91.298 2.595.982.684.684 1.042 1.63.982 2.595L8.791 5.63h.001z",
    transform: "translate(-40 -7149) translate(0 6947) translate(40 201)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.34fdd7c3a859b89478ffd0ca9a809f17.svg";
export { ForwardRef as ReactComponent };